<template>
  <div class="container-fluid d-flex flex-column p-0">
    <template v-if="$store.getters.getProductMode === 'WSD'">
      <DefaultLogin/>
    </template>
    <template v-else>
      <MeekijkenLogin/>
    </template>
  </div>
</template>

<script>
import DefaultLogin from './Login/Default/Login.vue'
import MeekijkenLogin from './Login/Meekijken/Login.vue'
export default {
  name: 'Login',
  components: {
    DefaultLogin,
    MeekijkenLogin
  }
}
</script>

<style lang="scss" scoped>

</style>
